import PropTypes from 'prop-types';

export const AddressType = PropTypes.shape({
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  addressLine1: PropTypes.string.isRequired,
  addressLine2: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip5: PropTypes.string.isRequired,
  standardized: PropTypes.bool.isRequired,
});
